function isNotUndefined (num) {
    if (num){
        return num;
    } else {
        return 0;
    }
};

export default isNotUndefined;